// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ForumCommentAdd__blockedNotice":"pm_a bib_sn bib_sv bib_sw bib_kx bib_ky bib_ke undefined bib_vt"};